import { type FC } from 'react';
import { colors } from 'lib/colors';

export type ProjectStatus = 'suggested' | 'implemented' | 'planned';

const STATUS_LABELS: Record<ProjectStatus, string> = {
  suggested: 'Suggested',
  implemented: 'Implemented',
  planned: 'Planned',
};

const STATUS_COLORS: Record<ProjectStatus, string> = {
  suggested: colors.status.new, // blue
  implemented: colors.status.solved, // green
  planned: colors.alert, // yellow
};

export const ProjectStatusPill: FC<{ status?: string }> = ({ status }) => {
  // Default to 'implemented' if no value
  const normalized = (status?.toLowerCase() as ProjectStatus) || 'implemented';
  const label = STATUS_LABELS[normalized] || STATUS_LABELS.implemented;
  const color = STATUS_COLORS[normalized] || STATUS_COLORS.implemented;

  return (
    <div className="w-full h-full pr-2 py-3 inline-flex items-center gap-2 justify-start">
      <div
        className="rounded-full"
        style={{ width: 10, height: 10, background: color }}
      />
      <div
        className="flex-1 flex flex-col justify-center text-xs uppercase"
        style={{ color: colors['gray-50'] }}
      >
        {label}
      </div>
    </div>
  );
};
